import api from './axiosConfig';

export interface PunchSettingsPayload {
  tenantId: string;
  isSelfieRequiredCheckIn: boolean;
  isSelfieRequiredCheckOut: boolean;
  checkoutLocationMode: 'FLEXIBLE' | 'STRICT';
  isGeofenceEnabled: boolean;
  isWebCheckinEnabled: boolean;
  webCheckinDefault: boolean;
  isWebSelfieCheckinRequired: boolean;
  isWebSelfieCheckoutRequired: boolean;
  isEmployeeFaceAttendanceEnabled: boolean;
  isSupervisorEntryEnabled: boolean;
  isLiveTrackingEnabled: boolean;
}

export const punchSettingsApi = {
  getByTenant: async (tenantId: string): Promise<PunchSettingsPayload> => {
    const response = await api.get<PunchSettingsPayload>(`/punch-settings/${tenantId}`);
    return response.data;
  },

  save: async (payload: PunchSettingsPayload): Promise<{ id: string; message: string }> => {
    const response = await api.post<{ id: string; message: string }>('/punch-settings', payload);
    return response.data;
  },
};
